





























import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

@Component({
  name: 'TotalInformationCard',
  props: {
    translations: {
      type: Object,
      default: () => {},
    },
    actualApartment: {
      type: Object,
      default: () => {},
    },
    startDate: {
      type: String,
      default: '',
    },
    endDate: {
      type: String,
      default: '',
    },
  },
})
export default class TotalInformationCard extends Vue {}
